// File: src/utils/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

// Fail loudly: createClient() throws a vague "supabaseUrl is required" at module
// load, which kills the whole App import chain and renders a blank white page.
// Note CRA only exposes REACT_APP_-prefixed vars, and only reads .env at startup.
const missing = [
  !supabaseUrl && 'REACT_APP_SUPABASE_URL',
  !supabaseKey && 'REACT_APP_SUPABASE_KEY',
].filter(Boolean);

if (missing.length) {
  throw new Error(
    `Missing ${missing.join(' and ')} — add ${missing.length > 1 ? 'them' : 'it'} to .env ` +
      `(REACT_APP_ prefix required) and restart npm start.`
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
